import { AsyncSelectValue } from "../../components/AsyncSelect";



// actual day type
// type DaySlot = {
//   locations?: { [k in string]: string } | null;
//   virtual: boolean;
// } & SData;

type BlockDays = {
  fullDay: boolean;
  startTime: Date | null;
  endTime: Date | null;
};

// combine day slots and block slot type
export type SlotData = {
  setToWeekdays: boolean;
  // minNoticeTime: undefined | number;
  // minNoticeUnit: undefined | string;
  providerId: AsyncSelectValue | null;
  bookingWindow: string;
  timezone: string;
  startTime?: string;
  blockDays: BlockDays[];
  bufferTime: number;
  initialConsultTime: number;
  followupConsultTime: number;
  settings?: any[];
} & {
  // [d in Days]: {
  //   daySlot: DaySlot[];
  // };
  daySlots: {
    day:
      | "MONDAY"
      | "TUESDAY"
      | "WEDNESDAY"
      | "THURSDAY"
      | "FRIDAY"
      | "SATURDAY"
      | "SUNDAY";
    startTime: string;
    endTime: string;
    location: any;
    availabilityMode: "IN_PERSON" | "VIRTUAL";
  }[];
};

export const initialDaysData: SlotData = {
  setToWeekdays: false,
  // minNoticeTime: undefined,
  // minNoticeUnit: undefined,
  providerId: null,
  bookingWindow: "",
  timezone: "",
  bufferTime: 0,
  initialConsultTime: 0,
  followupConsultTime: 0,
  startTime: new Date().toISOString(),
  settings: [],
  blockDays: [
    {
      startTime: null,
      endTime: null,
      fullDay: true,
    },
  ],
  daySlots: [
    {
      day: "MONDAY",
      startTime: "",
      endTime: "",
      availabilityMode: "IN_PERSON",
      location: undefined,
    },
    {
      day: "TUESDAY",
      startTime: "",
      endTime: "",
      availabilityMode: "IN_PERSON",
      location: undefined,
    },
    {
      day: "WEDNESDAY",
      startTime: "",
      endTime: "",
      availabilityMode: "IN_PERSON",
      location: undefined,
    },
    {
      day: "THURSDAY",
      startTime: "",
      endTime: "",
      availabilityMode: "IN_PERSON",
      location: undefined,
    },
    {
      day: "FRIDAY",
      startTime: "",
      endTime: "",
      availabilityMode: "IN_PERSON",
      location: undefined,
    },
    {
      day: "SATURDAY",
      startTime: "",
      endTime: "",
      availabilityMode: "IN_PERSON",
      location: undefined,
    },
    {
      day: "SUNDAY",
      startTime: "",
      endTime: "",
      availabilityMode: "IN_PERSON",
      location: undefined,
    },
  ],
};


